// extracted by mini-css-extract-plugin
export default {"button-wrapper":"user_button-wrapper__Ll27W","search-input":"user_search-input__WWz5Q","submit-button":"user_submit-button__IX5-N"};